import { OverlayProvider } from 'react-aria';
import { useOverlayTriggerState } from 'react-stately';
import { Button, Popup } from '@/components/common';
import { Routes } from '@/constants/routes';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { Spinner } from '@/components/common/Spinner';
import { AuthUserResponse, useGetUserQuery } from '@/api';
import { Roles } from '@/constants/roles';
import { useRouter } from 'next/router';
import { useLocalStorage } from 'usehooks-ts';
import { USER_DETAILS } from '@/constants/storage';
import completed from '../../../../public/animations/payment-completed.json';
import { Verification } from '../Verification';
import styles from './Welcome.module.css';

interface WelcomeProps {
  firstName?: string;
}

export const Welcome = ({ firstName }: WelcomeProps) => {
  const state = useOverlayTriggerState({});
  const { isDesktop } = useMediaQuery();
  const router = useRouter();
  const [, setUser] = useLocalStorage<null | AuthUserResponse>(USER_DETAILS, {});
  const { refetch: getUser } = useGetUserQuery({
    onSuccess(data) {
      setUser(data);
      const role = data?.userType === 'BUSINESS' ? Roles.BUSINESS : Roles.PERSONAL;
      router.push(`/${role}${Routes.WELCOME}`);
    },
    enabled: false,
  });

  return (
    <div className={styles.main}>
      <Spinner animationData={completed} side={isDesktop ? 56 : 60} />

      <h2 className={styles.title}>Welcome{firstName ? `, ${firstName}` : ''}!</h2>
      <p className={styles.description}>Congrats, you’ve created a new account. To finalize setting up you need to:</p>
      <ul className={styles.list}>
        <li className={styles.listItem}>Confirm your email;</li>
        <li className={styles.listItem}>Upload documents;</li>
        <li className={styles.listItem}>Add settlement information.</li>
      </ul>
      <OverlayProvider>
        <Button onPress={state.open} fluid size={isDesktop ? 'large' : 'medium'} className={styles.button}>
          Start Verification
        </Button>
        <Popup
          isOpen={state.isOpen}
          onClose={state.close}
          dialogClassName={styles.verificationPopup}
          hasCloseIcon
          isDismissable
        >
          <Verification />
        </Popup>
      </OverlayProvider>
      <Button variants="subtle" onPress={() => getUser()} className={styles.link} size="mediumSubtle">
        Skip for Now
      </Button>
    </div>
  );
};
